/** BFP-264 / TC-SPW2-12 — force-reset OTP expiry inline message. */
export const SP_OTP_EXPIRED_MESSAGE =
  'Your OTP has expired. Please request a new one.'

/** SP OTP lockout / resend cooldown when API omits retry metadata (story: 2 minutes). */
export const SP_OTP_LOCKOUT_FALLBACK_SECONDS = 120

/** BFP-264 / TC-SPW2-13 — OTP send/resend delivery failure toast. */
export const SP_OTP_SEND_FAILED_MESSAGE =
  'OTP could not be sent. Please try again.'

/** Inline OTP field error when verify/resend fails due to network or unreachable API — shown as toast. */
export const SP_NETWORK_ERROR_MESSAGE = 'Network error'
